<button type="button" mat-icon-button [ngClass]="{active: active === Style.light}" (click)="setStyle(Style.light)">
  <net-iconify-icon [icon]="icons.IC_ROUND_BRIGHTNESS_5"></net-iconify-icon>
</button>
<button type="button" mat-icon-button [ngClass]="{active: active === Style.default}" (click)="setStyle(Style.default)">
  <net-iconify-icon [icon]="icons.IC_ROUND_BRIGHTNESS_6"></net-iconify-icon>
</button>
<button type="button" mat-icon-button [ngClass]="{active: active === Style.dark}" (click)="setStyle(Style.dark)">
  <net-iconify-icon [icon]="icons.IC_ROUND_BRIGHTNESS_4"></net-iconify-icon>
</button>